export default {
  addDivision: '/academicReference/createAcademicReferenceForADivision',
  getDepartments: '/academicReference/getDepartments',
  getCourseYears: '/academicReference/getCourseYears',
  getDivisions: '/academicReference/getDivisions',
  getDivisionsOfAnInstitute: '/academicReference/getDivisionsOfAnInstitute',
  removeDepartment: '/academicReference/deleteAcademicReferenceForADepartment',
  removeCourseYear: '/academicReference/deleteAcademicReferenceForACourseYear',
  removeDivision: '/academicReference/deleteAcademicReferenceForADivision'
}
